import { IApplicationState } from '../../types/redux';

export function selectCurrentRegion(state: IApplicationState) {
  return state.region.currentRegion;
}
